import { Row } from '@components/main/spreading/models/models';
import { SpreadingState } from '@components/main/spreading/state/manager';
import { RoundingService } from '@services/rounding.service';

export function readonlyTemplateLabel(row: Row, viewInNativeLanguage: boolean): string {
  if (row.userFacingLabel) {
    return row.userFacingLabel;
  }
  if (row.template || viewInNativeLanguage) {
    return row.label ?? '';
  }
  return row.translatedLabel || row.label || '';
}

/** Uncategorized rows carry categorizedTo 0, not null. */
export function isRowCategorized(row: Row): boolean {
  return !!row?.categorizedTo;
}

export function editableSourceLabel(row: Row, viewInNativeLanguage: boolean): string {
  return row.userFacingLabel
    ? row.userFacingLabel
    : viewInNativeLanguage
      ? row.label
      : row.translatedLabel || row.label;
}

function roundedOrNull(
  state: SpreadingState,
  row: Row,
  raw: number | null | undefined,
  roundingService: RoundingService
): { rounded: number } | null {
  if (!state || raw === null || raw === undefined || (typeof raw === 'number' && isNaN(raw))) {
    return null;
  }
  return { rounded: roundingService.roundCellValue(state, row, raw) };
}

export function templateCellRoundedDisplay(
  state: SpreadingState,
  row: Row,
  colIdx: number,
  roundingService: RoundingService
): { rounded: number } | null {
  const cell = row.cells?.[colIdx];
  if (!cell) {
    return null;
  }
  const raw = (cell.itemRowValue || cell.value) as number | null | undefined;
  return roundedOrNull(state, row, raw, roundingService);
}

export function templateOffByRoundedDisplay(
  state: SpreadingState,
  row: Row,
  colIdx: number,
  roundingService: RoundingService
): { rounded: number } | null {
  const cell = row.cells?.[colIdx];
  if (!cell || cell.offBy === null || cell.offBy === undefined) {
    return null;
  }
  if (typeof cell.offBy === 'number' && isNaN(cell.offBy)) {
    return null;
  }
  return roundedOrNull(state, row, cell.offBy, roundingService);
}

export function templateRollupValueRoundedDisplay(
  state: SpreadingState,
  row: Row,
  colIdx: number,
  roundingService: RoundingService
): { rounded: number } | null {
  const cell = row.cells?.[colIdx];
  if (!cell) {
    return null;
  }
  const raw = cell.value as number | null | undefined;
  return roundedOrNull(state, row, raw, roundingService);
}

export function previousCellRoundedDisplay(
  state: SpreadingState,
  row: Row,
  pIdx: number,
  roundingService: RoundingService
): { rounded: number } | null {
  const cell = row?.previousCells?.[pIdx];
  if (!cell) {
    return null;
  }
  const raw = cell.value as number | null | undefined;
  return roundedOrNull(state, row, raw, roundingService);
}

export function previousOffByRoundedDisplay(
  state: SpreadingState,
  row: Row,
  pIdx: number,
  roundingService: RoundingService
): { rounded: number } | null {
  const cell = row?.previousCells?.[pIdx];
  if (!cell || cell.offBy === null || cell.offBy === undefined) {
    return null;
  }
  if (typeof cell.offBy === 'number' && isNaN(cell.offBy)) {
    return null;
  }
  return roundedOrNull(state, row, cell.offBy, roundingService);
}
